<template>
  <div>
    <filtro
      :codigo-beneficiario="codigoBeneficiario"
      @baixar-demonstrativo="baixarDemonstrativo"
      @baixar-todos-demonstrativos="baixarDemonstrativoIrTodos"
      @buscar-demonstrativo="buscarDemonstrativo"
      @show-loading="showLoading"
    ></filtro>
    <v-card colum class="px-5 pb-2 pt-5" color="accent" v-if="demonstrativo">
      <v-layout column justify-center>
        <v-card fill-height style="display: grid; margin: auto; width: 100%">
          <div
            color="white"
            ref="content"
            style="overflow: auto; padding: 16px; width: 100%"
          >
            <pdf :src="demonstrativo.content"></pdf>
          </div>
        </v-card>
      </v-layout>
    </v-card>
    <loading-dialog
      :show="isLoading"
      :message="loadingMessage"
    ></loading-dialog>
  </div>
</template>

<script>
import mime from "mime-types";
import pdf from "vue-pdf";

import { createNamespacedHelpers } from "vuex";

import LoadingDialog from "@/components/LoadingDialog";
import {
  baixarDemonstrativoIr,
  baixarDemonstrativoIrTodosContratos
} from "@/services/beneficiario";
import { download } from "@/utils/download";

import Filtro from "./filtro";

const { mapMutations } = createNamespacedHelpers("portal");
const { mapGetters } = createNamespacedHelpers("beneficiario");

export default {
  name: "DemonstrativoIrVisualizar",
  components: {
    Filtro,
    LoadingDialog,
    pdf
  },
  props: {
    codigoBeneficiario: String
  },
  data() {
    return {
      demonstrativo: null,
      isLoading: false,
      loadingMessage: null
    };
  },
  watch: {
    codigoBeneficiario: {
      handler() {
        this.demonstrativo = null;
      }
    }
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    async baixarDemonstrativo() {
      download(this.demonstrativo.data, this.demonstrativo.filename);
    },
    baixarDemonstrativoIrTodos(beneficiarioPrincipalTodosContratos, ano) {
      baixarDemonstrativoIrTodosContratos(
        beneficiarioPrincipalTodosContratos,
        ano
      ).then(({ headers, data }) => {
        if (data?.error) {
          const errorMessage = data.message;

          this.setErrorToast(errorMessage);
        } else {
          const filename = headers["content-disposition"].replace(
            "attachment; filename=",
            ""
          );

          download(data, filename);
        }
      });
    },
    buscarDemonstrativo(ano) {
      this.isLoading = true;

      baixarDemonstrativoIr(this.codigoBeneficiario, ano)
        .then(({ headers, data }) => {
          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          } else {
            const filename = headers["content-disposition"].replace(
              "attachment; filename=",
              ""
            );
            const content = `data:${mime.contentType(filename)};base64,${data}`;

            this.demonstrativo = { filename, content, data };
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showLoading(valor) {
      this.isLoading = valor;
    }
  },
  computed: {
    ...mapGetters(["getFamiliaPessoa"])
  }
};
</script>
